import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Link from 'next/link';
import React from 'react';
import styled from 'styled-components';
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  width: 300px;\n  margin: auto;\n  padding-top: 10vh;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
export default function Custom404() {
    return(/*#__PURE__*/ _jsxs(Wrapper, {
        children: [
            /*#__PURE__*/ _jsx("h1", {
                children: "404 not found"
            }),
            /*#__PURE__*/ _jsx(Link, {
                href: "/",
                children: /*#__PURE__*/ _jsx("a", {
                    children: /*#__PURE__*/ _jsx("h2", {
                        children: "back to homepage"
                    })
                })
            })
        ]
    }));
};
var Wrapper = styled.div(_templateObject());
